<template>
  <el-dialog custom-class="add-invoce-rest" title="新增发票类目" :close-on-click-modal="false" :visible.sync="visible">
    <el-table :border="true" size="small">
      <el-table-column label="发票类型"> </el-table-column>
      <el-table-column label="是否支持">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isSupport"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="余量是否充足">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isEnough"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="发票张数">
        <template slot-scope="scope">
          <el-input-number v-model="scope.row.invoceCount" controls-position="right"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="可开票金额">
        <template slot-scope="scope">
          <el-input-number v-model="scope.row.invoiceAmount" controls-position="right"></el-input-number>
        </template>
      </el-table-column>
    </el-table>
    <div class="dialog-tip">
      温馨提示：
      <span>
        1、请及时维护贵司支持的发票类型及其余量。
        若发票余量不足，平台将向企业优先推荐其他服务商。贵司领用发票并更新余量后，企业即可重新选择贵司开展业务。
      </span>
      <span>
        2、系统每月1号会自动根据上月末贵司支持的发票类型，自动新增余量充足的记录。
      </span>
    </div>
    <span slot="footer" class="invoice-footer">
      <el-button size="small" @click="handleClose">取消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'setAmount',
  data() {
    return {
      visible: false,
      data: [
        {
          isSupport: false,
          isEnough: false,
          invoiceCount: 0,
          invoiceAmount: 0,
        },
        {
          isSupport: false,
          isEnough: false,
          invoiceCount: 0,
          invoiceAmount: 0,
        },
        {
          isSupport: false,
          isEnough: false,
          invoiceCount: 0,
          invoiceAmount: 0,
        },
        {
          isSupport: false,
          isEnough: false,
          invoiceCount: 0,
          invoiceAmount: 0,
        },
      ],
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
    },
    handleConfirm() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.add-invoce-rest {
  .dialog-tip {
    margin-top: 17px;
    border: 1px solid #ffcd61;
    color: rgba(0, 0, 0, 0.65);
    background-color: #fffcf2;
    padding: 8px 12px;
    > span {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoice/components/addInvoiceRest.vue